import React from 'react';
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { RootState } from '../../reducers';

const rotate = keyframes`
	0%   { transform: rotate(0);      }
	100% { transform: rotate(360deg); }
`;

const StyledLoader = styled.div`
	height: 48px;
	width: 48px;
	border: 5px solid rgba(150, 150, 150, 0.2);
	border-radius: 50%;
	border-top-color: rgb(150, 150, 150);
	animation: ${rotate} 1s 0s infinite linear normal;
	margin: 2rem auto;

	${({ small }) =>
		small &&
		`
		border: 3px solid rgba(150, 150, 150, 0.2);
		border-top-color: rgb(150, 150, 150);
		height: 2rem;
		width: 2rem;
		margin: 0;
	`}
`;

const RawLoader = ({ ...rest }) => <StyledLoader {...rest} />;

const Loading = () => {
	const loading = useSelector((state: RootState) => state.pageReducer.loading);

	return loading && <RawLoader />;
};

export default Loading;
export { RawLoader };
